module.exports = __webpack_public_path__ + "img/img17.7963cca2.jpg";